import http from "../js/axios";

class ABDMService {
  // ==========================================
  // 1. Session APIs
  // ==========================================
  getSessionToken() {
    return http.post("/ABDM/session_token");
  }

  getCertificate() {
    return http.get("/ABDM/session_certificate");
  }

  // ==========================================
  // 2. Enrollment APIs (Create New ABHA)
  // ==========================================
  enrollmentRequestOtp(data) {
    return http.post("/ABDM/enrollment_request_otp", data);
  }

  enrollByAadhaar(data) {
    return http.post("/ABDM/enrollment_enrol_aadhaar", data);
  }

  enrollmentMobileRequestOtp(data) {
    return http.post("/ABDM/enrollment_mobile_request_otp", data);
  }

  enrollmentMobileVerify(data) {
    return http.post("/ABDM/enrollment_mobile_verify", data);
  }

  enrollmentGetSuggestions(data) {
    return http.post("/ABDM/enrollment_suggestions", data);
  }

  enrollmentCreateAddress(data) {
    return http.post("/ABDM/enrollment_create_address", data);
  }

  enrollmentEmailVerification(data) {
    return http.post("/ABDM/enrollment_email_verification", data);
  }

  enrollByDocument(data) {
    return http.post("/ABDM/enrollment_enrol_document", data);
  }

  enrollByDemoAuth(data) {
    return http.post("/ABDM/enrollment_enrol_demoauth", data);
  }

  enrollByBiometric(data) {
    return http.post("/ABDM/enrollment_enrol_biometric", data);
  }

  // Face Auth (QR-based)
  faceAuthInit() {
    return http.post("/ABDM/enrollment_face_auth_init");
  }

  faceCapturePID(data) {
    return http.post("/ABDM/enrollment_face_capture_pid", data);
  }

  faceAuthEnroll(data) {
    return http.post("/ABDM/enrollment_face_auth_enroll", data);
  }

  // ==========================================
  // 3. Login APIs (Existing ABHA Verification)
  // ==========================================
  loginRequestOtp(data) {
    return http.post("/ABDM/login_request_otp", data);
  }

  loginVerify(data) {
    return http.post("/ABDM/login_verify", data);
  }

  loginVerifyUser(data) {
    return http.post("/ABDM/login_verify_user", data);
  }

  loginSearch(data) {
    return http.post("/ABDM/login_search", data);
  }

  loginByPassword(data) {
    return http.post("/ABDM/login_by_password", data);
  }

  loginVerifyBiometric(data) {
    return http.post("/ABDM/login_verify_biometric", data);
  }

  // ==========================================
  // 4. Account APIs (Profile, Card, Update)
  // ==========================================
  getProfile(data) {
    return http.post("/ABDM/account_profile", data);
  }

  getAbhaCard(data) {
    return http.post("/ABDM/account_abha_card", data);
  }

  getQrCode(data) {
    return http.post("/ABDM/account_qr_code", data);
  }

  checkAbhaUnique(data) {
    return http.post("/ABDM/check_abha_unique", data);
  }

  updatePhoto(data) {
    return http.post("/ABDM/account_update_photo", data);
  }

  accountRequestOtp(data) {
    return http.post("/ABDM/account_request_otp", data);
  }

  accountVerifyOtp(data) {
    return http.post("/ABDM/account_verify_otp", data);
  }

  accountPassword(data) {
    return http.post("/ABDM/account_password", data);
  }

  accountDelete(data) {
    return http.post("/ABDM/account_delete", data);
  }

  accountDeactivate(data) {
    return http.post("/ABDM/account_deactivate", data);
  }

  accountReactivate(data) {
    return http.post("/ABDM/account_reactivate", data);
  }

  forgotAbhaRequestOtp(data) {
    return http.post("/ABDM/account_forgot_request_otp", data);
  }

  forgotAbhaVerify(data) {
    return http.post("/ABDM/account_forgot_verify", data);
  }

  logout(data) {
    return http.post("/ABDM/account_logout", data);
  }

  refreshToken(data) {
    return http.post("/ABDM/account_refresh_token", data);
  }

  // ==========================================
  // 5. ABHA Address APIs (PHR web login)
  // ==========================================
  abhaAddressSearch(data) {
    return http.post("/ABDM/abha_address_search", data);
  }

  abhaAddressRequestOtp(data) {
    return http.post("/ABDM/abha_address_request_otp", data);
  }

  abhaAddressVerify(data) {
    return http.post("/ABDM/abha_address_verify", data);
  }

  abhaAddressProfile(data) {
    return http.post("/ABDM/abha_address_profile", data);
  }

  abhaAddressPhrCard(data) {
    return http.post("/ABDM/abha_address_phr_card", data);
  }

  abhaAddressQrCode(data) {
    return http.post("/ABDM/abha_address_qr_code", data);
  }

  // ==========================================
  // 6. Benefit APIs
  // ==========================================
  benefitLinkDelink(data) {
    return http.post("/ABDM/benefit_link_delink", data);
  }

  benefitSearch(data) {
    return http.post("/ABDM/benefit_search", data);
  }

  benefitByAbha(data) {
    return http.post("/ABDM/benefit_by_abha", data);
  }

  benefitRequestOtp(data) {
    return http.post("/ABDM/benefit_request_otp", data);
  }

  benefitCreateAbha(data) {
    return http.post("/ABDM/benefit_create_abha", data);
  }

  benefitChildren(data) {
    return http.post("/ABDM/benefit_children", data);
  }

  benefitCreateChild(data) {
    return http.post("/ABDM/benefit_create_child", data);
  }

  // ==========================================
  // 7. Share Profile APIs
  // ==========================================
  shareProfileCallback(data) {
    return http.post("/ABDM/share_profile_callback", data);
  }

  shareProfileGenerateQr(data) {
    return http.post("/ABDM/share_profile_generate_qr", data);
  }
}

export default new ABDMService();
